import React from 'react';
import PropTypes from 'prop-types';
import { Form, Checkbox } from 'antd';

import './checkBox.scss';
const { Item } = Form;

const CheckboxGroup = Checkbox.Group;
const IndividualCheckBox = ({
  data = [],
  checkBoxName,
  isShowUpText = true,
  upTextStyles = {},
  isShowDownText = false,
  downTextStyles = {},
  name = '',
  style = {},
  itemKey,
  disabled,
  label,
  click = () => {},
}) => (
  <Item name={name} style={style} key={itemKey} label={label}>
    <CheckboxGroup
      disabled={disabled}
      className={`individual-check-box ${checkBoxName}`}
      onChange={(e) => click(e, name)}
    >
      {Array.isArray(data) &&
        data.map((item, idx) =>
          item.block ? (
            <div className={item.classname} />
          ) : (
            <Checkbox
              value={idx}
              key={idx}
              className={isShowDownText === true && 'isShowDownText'}
            >
              <span>
                {isShowUpText === true ? (
                  <span
                    style={{
                      position: 'absolute',
                      left: '0',
                      bottom: isShowDownText === true ? '68%' : '50%',
                      width: '100%',
                      textAlign: 'center',
                      fontSize: '0.875rem',
                      whiteSpace: 'pre-wrap',
                      ...upTextStyles,
                    }}
                  >
                    {item.text}
                  </span>
                ) : null}

                {isShowDownText === true ? (
                  <span
                    style={{
                      position: 'absolute',
                      left: '0',
                      bottom: '15%',
                      width: '100%',
                      textAlign: 'center',
                      fontSize: '0.875rem',
                      whiteSpace: 'pre-wrap',
                      ...downTextStyles,
                    }}
                  >
                    {idx + 1}
                  </span>
                ) : null}
              </span>
            </Checkbox>
          ),
        )}
    </CheckboxGroup>
  </Item>
);
IndividualCheckBox.propTypes = {
  data: PropTypes.array.isRequired,
  checkBoxName: PropTypes.string,
  isShowUpText: PropTypes.bool,
  isShowDownText: PropTypes.bool,
  name: PropTypes.string,
  upTextStyles: PropTypes.object,
  downTextStyles: PropTypes.object,
  style: PropTypes.object,
  itemKey: PropTypes.any,
  label: PropTypes.string,
  click: PropTypes.func,
};
export default IndividualCheckBox;
